// extracted by mini-css-extract-plugin
module.exports = {"match-group-home":"match-group-home","group-header":"group-header","group-matches":"group-matches"};